module.exports = __webpack_public_path__ + "img/99dca54.svg";